// Frontend version will only be present on frontend lookasides.
export function getFrontendVersion (urlString) {
    const url = new URL(urlString);

    return url.searchParams.get('version');
}

export function addFrontendVersionToRoute (route) {
    const versionQueryParam = getFrontendVersion(window.location.href);

    if (versionQueryParam) route.params.version = versionQueryParam;

    return route;
}
